export default {
  "content": "<rect width=\"40\" height=\"40\" rx=\"20\" fill=\"#1A1A1A\"/><path d=\"M26.657 10H13.342A3.342 3.342 0 0010 13.342v13.315A3.344 3.344 0 0013.342 30h13.315A3.344 3.344 0 0030 26.657V13.342A3.343 3.343 0 0026.657 10zm-.294 15.31a1.055 1.055 0 01-1.054 1.054H14.692a1.053 1.053 0 01-1.054-1.055V14.692a1.055 1.055 0 011.055-1.055h10.616a1.054 1.054 0 011.054 1.055v10.617z\" fill=\"#fff\"/><path d=\"M17.875 22.713a.604.604 0 01-.605-.607v-4.239a.605.605 0 01.605-.608h4.25a.605.605 0 01.605.608v4.239a.606.606 0 01-.605.607h-4.25z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "40",
    "height": "40",
    "viewBox": "0 0 40 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};